import { Icons } from '@/assets/icons/icons';
import { Button } from '@/components/ui/Button';

import { FeedKeyTooltip } from './FeedKeyTooltip';

// The open to-do's Mark done on the action band, a plain green tick. ⌘D presses it, as it checks off any card; a to-do
// without its own button also runs it on ⌘↵
export const FeedMarkDone = ({
  title,
  primary,
  onClick,
}: {
  title: string;
  primary: boolean;
  onClick: () => void;
}) => (
  <FeedKeyTooltip label="Mark done" keys={['mod', 'd']}>
    <Button
      variant="ghost"
      size="xs"
      iconOnly
      data-card-primary={primary || undefined}
      data-feed-mark-done=""
      aria-label={`Mark ${title} done`}
      className="shrink-0 text-kind-done hover:enabled:text-kind-done"
      onClick={onClick}
    >
      <Icons.check aria-hidden="true" />
    </Button>
  </FeedKeyTooltip>
);
